import { useHistory, } from 'react-router-dom'

export default function Button({ children, className, onClick, goto, type = "button", plainText, disabled = false, variant, border }) {
    const history = useHistory()

    function handleClick() {
        onClick?.()
        if (goto && typeof goto === "string") history.push(goto)
    }

    return (
        <button
            type={type}
            style={{ minWidth: plainText ? "min-content" : 120 }}
            className={`${getClasses(variant, border, disabled, plainText)} ${className ?? ""}`}
            onClick={handleClick}
            disabled={disabled}
        >{children}</button>
    )
}

function getClasses(variant, border, disabled, plainText) {
    const defaultClass = `w-full max-w-sm outline-none py-0 ${!plainText && "px-6"} h-12 rounded-lg flex items-center ${!plainText && "justify-center"} space-x-4
        text-base cursor-pointer whitespace-nowrap focus:outline-none disabled:opacity-50 capitalize animated
    `
    switch (variant) {
        case "outline":
            return `${defaultClass} border ${border || "border-gray-600"} bg-transparent hover:border-gray-400`
        case "transparent-outline":
            return `${defaultClass} border border-white bg-transparent text-white`
        case "light-gray":
            return `${defaultClass} bg-gray-100 border border-gray-300 hover:bg-gray-100 text-gray-700`
        case "light-blue":
            return `${defaultClass} bg-blue-50 border border-blue-200 hover:bg-blue-100 text-blue-700`
        case "solid-green":
            return `${defaultClass} bg-green-600 hover:bg-green-500 text-white`
        case "light-green":
            return `${defaultClass} bg-green-50 border border-green-200 hover:bg-green-100 text-green-700`
        case "light-red":
            return `${defaultClass} bg-red-50 border border-red-200 hover:bg-red-100 text-red-700`
        case "solid-red":
            return `${defaultClass} bg-red-600 hover:bg-red-500 text-white`
        case "transparent-text":
            return `${defaultClass} bg-transparent text-red-500`
        case "white":
            return `${defaultClass} bg-white text-gray-700`
        default:
            return `${defaultClass} ${disabled ? "bg-gray-500" : "bg-indigo-600 hover:bg-indigo-500"} text-white`
    }
}